import React, { Component } from "react";
import { Link } from "react-router-dom";
import EmailSignup from "./EmailSignup";
import Languages from "./Languages";

class Footer extends Component {
    render() {
        var menuItems = [];

        for (var x = 0; x < window.appMenus["footer-menu"].length; x++) {
            var item = window.appMenus["footer-menu"][x];
            if (item.path === "#") {
                menuItems.push({
                    label: item.label,
                    children: []
                });
            } else if (menuItems[menuItems.length - 1] && menuItems[menuItems.length - 1].children) {
                menuItems[menuItems.length - 1].children.push({
                    label: item.label,
                    path: item.path
                });
            }
        }

        var footerMenu = menuItems.map((section, key) => {
            var children = section.children.map((child, localKey) => {
                return <Link className="item" to={child.path} key={localKey}>{child.label}</Link>;
            });

            return <div className="footer-menu-wrap" key={key}>
                <span className="title">{section.label}</span>
                {children}
            </div>;
        });

        return <div className="footer">
            <EmailSignup />

            <Languages />

            <div className="footer-menu">
                {footerMenu}
            </div>

            <div className="legal-info">
                © Veronica Virta 2024
            </div>
        </div>
    }
}

export default Footer;